const hospitalId = 40    //医院id
export default hospitalId


// WEBPACK FOOTER //
// ./src/api/index.js